import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export type ConfigBadgeVariant =
  | 'popular'
  | 'medium'
  | 'low'
  | 'active'
  | 'needs-review'
  | 'deprecated';

export interface ConfigBadgeProps {
  variant: ConfigBadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const badgeVariants = {
  popular: {
    background: 'var(--color-polar-green-1)',
    border: 'var(--color-polar-green-3)',
    text: 'var(--color-polar-green-6)',
  },
  active: {
    background: 'var(--color-polar-green-1)',
    border: 'var(--color-polar-green-3)',
    text: 'var(--color-polar-green-6)',
  },
  medium: {
    background: 'var(--color-calendula-gold-1)',
    border: 'var(--color-calendula-gold-3)',
    text: 'var(--color-calendula-gold-6)',
  },
  'needs-review': {
    background: 'var(--color-calendula-gold-1)',
    border: 'var(--color-calendula-gold-3)',
    text: 'var(--color-calendula-gold-6)',
  },
  low: {
    background: 'var(--color-dust-red-1)',
    border: 'var(--color-dust-red-3)',
    text: 'var(--color-dust-red-5)',
  },
  deprecated: {
    background: 'var(--color-dust-red-1)',
    border: 'var(--color-dust-red-3)',
    text: 'var(--color-dust-red-5)',
  },
} as const;

export const ConfigBadge = forwardRef<HTMLDivElement, ConfigBadgeProps>(
  ({ variant, children, className }, ref) => {
    const styles = badgeVariants[variant];

    return (
      <div
        ref={ref}
        className={cn(
          'inline-flex items-center justify-center px-2 py-[3px] rounded-[100px] border border-solid',
          className
        )}
        style={{
          backgroundColor: styles.background,
          borderColor: styles.border,
        }}
      >
        <span
          className="font-roboto font-normal text-[12px] leading-[20px]"
          style={{ color: styles.text }}
        >
          {children}
        </span>
      </div>
    );
  }
);

ConfigBadge.displayName = 'ConfigBadge';
